import { render, staticRenderFns } from "./order.vue?vue&type=template&id=742dd460"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=742dd460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IdCheckoutTabs: require('/opt/app/components/checkout/Tabs.vue').default,IdCheckoutOrderItems: require('/opt/app/components/checkout/OrderItems.vue').default,IdCheckoutSpecialOffersList: require('/opt/app/components/checkout/special-offers/List.vue').default,IdCheckoutFavouriteItems: require('/opt/app/components/checkout/FavouriteItems.vue').default,IdCheckoutOrderSummary: require('/opt/app/components/checkout/OrderSummary.vue').default,IdButton: require('/opt/app/components/Button.vue').default,IdBuyInfo: require('/opt/app/components/BuyInfo.vue').default,IdModalsItemModal: require('/opt/app/components/modals/ItemModal.vue').default})
